import { render } from "./SamlDomainSwitcher.vue?vue&type=template&id=63f6e420&scoped=true"
import script from "./SamlDomainSwitcher.vue?vue&type=script&lang=js"
export * from "./SamlDomainSwitcher.vue?vue&type=script&lang=js"

import "./SamlDomainSwitcher.vue?vue&type=style&index=0&id=63f6e420&lang=less&scoped=true"

import exportComponent from "/home/pedro/git/cloudstack/scclouds/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63f6e420"]])

export default __exports__